import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Estado } from './estado.model';

@Injectable({
  providedIn: 'root'
})
export class EstadoService {
  listEstado:Estado[];
  estado:Estado;
  private routeApi = "AdmEstadoes";
  constructor(private generalHttp:GeneralHttpService) { }

  getEstado(){
    this.generalHttp.getHttp(this.routeApi).then(r => this.listEstado = r as Estado[]);
  }

  postEstado(form:Estado){
    return this.generalHttp.postHttp(form,this.routeApi);
  }

  putEstado(form:Estado,id:number){
    return this.generalHttp.putHttp(form,id,this.routeApi)
  }

  getEstadoById(id:number){
    this.generalHttp.getHttpById(id,this.routeApi).then(r => this.estado = r as Estado);
  }


  getEstadoByIdTipoEstado(id:number){
    return this.generalHttp.getHttpById(id,this.routeApi + "/ByTipoEstado").then(r=> this.listEstado = r as Estado[]);
  }
}
